import { getCookie } from '../../plugins/utils'

let returnState = null

export function customerListScope (route) {
  const token = getCookie('workbench_token')
  const agentId = (route && route.query && route.query.agentId) || getCookie('workbench_agentId')
  return token ? JSON.stringify([token, agentId || '']) : ''
}

export function saveCustomerListState (scope, state) {
  returnState = scope ? { scope, state: JSON.parse(JSON.stringify(state)) } : null
}

export function takeCustomerListState (scope) {
  const saved = returnState
  returnState = null
  return saved && saved.scope === scope ? saved.state : null
}

export function clearCustomerListState () {
  returnState = null
}

export function customerListReturnRoute (route) {
  const query = route && route.query ? route.query : {}
  if (query.from !== 'customer') return null
  const returnQuery = { tab: 'customer' }
  if (query.agentId) returnQuery.agentId = query.agentId
  return { path: '/customer', query: returnQuery }
}

export function captureCustomerListScroll (element) {
  const ancestors = []
  for (let current = element; current; current = current.parentElement) {
    ancestors.push({ top: current.scrollTop, left: current.scrollLeft })
  }
  return { ancestors, top: window.pageYOffset, left: window.pageXOffset }
}

export function restoreCustomerListScroll (element, scroll) {
  if (!scroll) return
  let current = element
  ;(scroll.ancestors || []).forEach(position => {
    if (!current) return
    current.scrollTop = position.top
    current.scrollLeft = position.left
    current = current.parentElement
  })
  window.scrollTo(scroll.left || 0, scroll.top || 0)
}
